<template>
  <div class="common-layout">
    <BgManageTopbar />
    <div class="layout-container">
      <!-- 左侧菜单 -->
      <div class="sidebar" v-if="userInfo.type!=5">
        <div class="pd20">
          <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          @select="handleSelect"
          router
        >
        <div>
          <img src="@/assets/ucenterLogo.png" class="logo" alt="">
        </div>
        <div v-if="userInfo.type==1">
          <el-menu-item index="/bgManage/projectIntroduction">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc1.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">双推双促工程介绍</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/achievementRegistration">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc2.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">申报成果信息登记</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/achievementPreview">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">申报成果信息预览</div>
              
            </div>
          </el-menu-item>
        </div>
        <div v-if="userInfo.type==2 || userInfo.type==3 || userInfo.type==4">
          <el-menu-item index="/bgManage/pendingPersonal">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">待{{userInfo.type==4?'个人':'单位'}}推荐成果</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/recommendedPreview">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">已推荐成果预览</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/unrecommendedPreview">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">未推荐成果预览</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/recommendAll">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">推荐{{userInfo.type==4?'个人':'单位'}}全部成果</div>
              
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/recommendUsers">
            <div class="menuDiv">
              <div>
                <img src="@/assets/uc3.png" class="uc1Img" alt="">
              </div>
              <div class="menuText">推荐{{userInfo.type==4?'个人':'单位'}}已注册用户</div>
            </div>
          </el-menu-item>
        </div>
        <div v-if="userInfo.type==5">
          <!-- <el-menu-item index="/bgManage/secondDeclaration">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">第二届新动能成果申报(2026年)</div>
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/firstConferenceAchievements">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">第一届发布会成果(100)</div>
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/nominatedAchievement">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">第一届提名成果(150)</div>
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/firstShortlistedAchievements">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">第一届入围成果(全部)</div>
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/nonAchievementCooperationList">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">非成果方成果合作服务申请列表</div>
            </div>
          </el-menu-item>
          <el-menu-item index="/bgManage/achievementExtensionServiceList">
            <div class="menuDiv">
              <div><img src="@/assets/uc3.png" class="uc1Img" alt=""></div>
              <div class="menuText">成果方成果延伸服务申请列表</div>
            </div>
          </el-menu-item> -->
        </div>


        </el-menu>
        </div>
     
        <div class="anchorLine " v-if="showAnchor">

        </div>
        <!-- 锚点导航 -->
        <div class="anchor-nav pd20" v-if="showAnchor">
          <div
            v-for="(item, index) in anchorList"
            :key="item.id"
            class="anchor-item"
            :class="{ 'anchor-active': currentAnchor === item.id }"
            @click="scrollToAnchor(item.id)"
          >
            <div class="anchor-line" v-if="index > 0"></div>
            <div class="anchor-content">
              <div class="anchor-text">{{ item.title }}</div>
              <div class="anchor-dot" :class="{ 'dot-active': currentAnchor === item.id }"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧内容 -->
      <div class="main-content" :class="{ 'no-background': isExpertJudgesRoute }">
        <router-view />
      </div>
    </div>
    <!-- <CommonFooter /> -->
  </div>
</template>

<script>
import BgManageTopbar from '../components/BgManageTopbar.vue'
import CommonFooter from '../components/CommonFooter.vue'
import { mapState } from 'vuex'
export default {
  name: 'CommonLayout',
  components: {
    BgManageTopbar,
    CommonFooter
  },

  data() {
    return {
      activeMenu: '/bgManage/projectIntroduction',
      currentAnchor: 'section-unit',
      anchorList: [
        { id: 'section-unit', title: '申报单位信息' },
        { id: 'section-achievement', title: '申报成果信息' },
        { id: 'section-innovation', title: '技术创新亮点' },
        { id: 'section-market', title: '市场价值要点' },
        { id: 'section-transformation', title: '转化要素难点' },
        { id: 'section-rd-leader', title: '研发负责人' },
        { id: 'section-rd-team', title: '研发团队' },
        { id: 'section-applicant', title: '成果申报人信息' },
        { id: 'section-recommend', title: '推荐单位/个人' },
        { id: 'section-upload', title: '附件上传' }
      ],
      anchorObserver: null
    }
  },
  computed: {
    showAnchor() {
      return this.$route.path === '/bgManage/achievementRegistration'
    },
    isExpertJudgesRoute() {
      console.log("55555",this.$route)
      return this.$route.path.includes('judge')
    },
    ...mapState('userAbout', ['userInfo', 'isLogin']),
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path
      if (this.showAnchor) {
        this.$nextTick(() => {
          this.initAnchorObserver()
        })
      } else {
        this.destroyAnchorObserver()
      }
    }
  },
  mounted() {
    this.activeMenu = this.$route.path
    if (this.showAnchor) {
      // 初始化默认选中第一个锚点
      this.currentAnchor = this.anchorList[0]?.id || ''
      this.$nextTick(() => {
        this.initAnchorObserver()
        // 延迟标记 observer 已就绪，避免初始化时覆盖高亮
        setTimeout(() => {
          this.observerReady = true
        }, 100)
      })
    }
  },
  beforeDestroy() {
    console.log("销毁")
    this.destroyAnchorObserver()
  },
  methods: {
    handleSelect(){
      this.currentAnchor = this.anchorList[0]?.id || ''
    },
    // 根据滚动位置计算当前高亮的锚点
    updateCurrentAnchorByScroll() {
      if (this.isScrolling) return
      
      const mainContent = document.querySelector('.main-content')
      if (!mainContent) return
      
      const scrollTop = mainContent.scrollTop
      const scrollHeight = mainContent.scrollHeight
      const clientHeight = mainContent.clientHeight
      
      // 如果已经滚动到底部，返回最后一个锚点
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.currentAnchor = this.anchorList[this.anchorList.length - 1].id
        return
      }
      
      // 找到当前视口顶部下方的第一个锚点
      for (let i = 0; i < this.anchorList.length; i++) {
        const element = document.getElementById(this.anchorList[i].id)
        if (element) {
          const offsetTop = element.offsetTop - mainContent.offsetTop - 20
          if (offsetTop > scrollTop + 50) {
            // 前一个锚点是当前高亮的
            this.currentAnchor = this.anchorList[i - 1]?.id || ''
            return
          }
        }
      }
      
      // 默认第一个
      this.currentAnchor = this.anchorList[0]?.id || ''
    },
    
    scrollToAnchor(anchorId) {
      // 点击时直接设置目标锚点
      this.currentAnchor = anchorId
      
      const element = document.getElementById(anchorId)
      if (element) {
        const mainContent = document.querySelector('.main-content')
        if (mainContent) {
          const targetScrollTop = element.offsetTop - mainContent.offsetTop - 20
          const startScrollTop = mainContent.scrollTop
          const distance = targetScrollTop - startScrollTop
          const duration = 300
          const startTime = performance.now()
          
          const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime
            const progress = Math.min(elapsed / duration, 1)
            
            // easeOutQuad 缓动函数
            const easeProgress = 1 - (1 - progress) * (1 - progress)
            
            mainContent.scrollTop = startScrollTop + distance * easeProgress
            
            if (progress < 1) {
              requestAnimationFrame(animateScroll)
            } else {
              // 滚动结束后再次确认高亮
              this.updateCurrentAnchorByScroll()
            }
          }
          
          requestAnimationFrame(animateScroll)
        }
      }
    },
    initAnchorObserver() {
      this.destroyAnchorObserver()
      
      // 使用 MutationObserver 监听 DOM 变化（表单展开/收起时）
      this.anchorObserver = new MutationObserver(() => {
        this.updateCurrentAnchorByScroll()
      })
      
      const mainContent = document.querySelector('.main-content')
      if (mainContent) {
        this.anchorObserver.observe(mainContent, {
          childList: true,
          subtree: true
        })
        
        // 监听滚动事件
        mainContent.addEventListener('scroll', this.onScroll)
      }
    },
    onScroll() {
      console.log("55555")
      // 使用节流，避免频繁更新
      if (this.scrollTimer) return
      this.scrollTimer = requestAnimationFrame(() => {
        this.updateCurrentAnchorByScroll()
        this.scrollTimer = null
      })
    },
    destroyAnchorObserver() {
      if (this.anchorObserver) {
        this.anchorObserver.disconnect()
        this.anchorObserver = null
      }
      const mainContent = document.querySelector('.main-content')
      if (mainContent) {
        mainContent.removeEventListener('scroll', this.onScroll)
      }
      if (this.scrollTimer) {
        cancelAnimationFrame(this.scrollTimer)
        this.scrollTimer = null
      }
      this.observerReady = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pd20{
  padding: 20px;
}
::v-deep .el-menu-item{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #231815;
padding: 0 !important;
}
.menuDiv{
  display: flex;
  align-items: center;

}
.anchorLine{
  height: 10px;
  background: #f5f5f5;
}
.uc1Img{
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
::v-deep .el-menu-item.is-active{
  background: none !important;
font-family: Microsoft YaHei, Microsoft YaHei !important; 
font-weight: 400 !important;
font-size: 14px !important;
color: #2F86FF !important;

}
.logo{
  width: 100%;
}
.common-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.layout-container {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.sidebar {
  width: 280px;
  background: #fff;
  border-radius: 4px;
  margin-right: 20px;
  height: 100%;
  
  .sidebar-menu {
    border-right: none;
    
    .el-menu-item {
      &:hover {
        background: #ecf5ff;
        color: #409EFF;
      }
      
      &.is-active {
        background: #409EFF;
        color: #fff;
      }
    }
  }
}

.main-content {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 160px);
  
  &.no-background {
    background: none !important;
    padding: 0;
     max-height: calc(100vh - 160px) !important;
  }
}

// 锚点导航样式


.anchor-title {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
  padding-left: 10px;
}

.anchor-item {
  position: relative;
  cursor: pointer;
  padding: 10px 0;
}

.anchor-line {
  position: absolute;
  right: 14px;
  top: -15px;
  width: 1px;
  height: 30px;
  background: #ddd;
}

.anchor-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.anchor-text {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 13px;
  color: #666;
  flex: 1;
}

.anchor-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  flex-shrink: 0;
  margin-left: 10px;
  transition: all 0.3s;
}

.anchor-active .anchor-text {
  color: #2F86FF;
  font-weight: 500;
}

.anchor-active .anchor-dot,
.dot-active {
  background: #2F86FF;
  box-shadow: 0 0 0 3px rgba(47, 134, 255, 0.2);
}
</style>
